<template>
<div>
  <a-row>
    <a-col :span="20" :offset="2" class="css_container">
      <a-card class="css_card" hoverable>
        <p slot="title" class="css_card_title">Password Reset</p>
        <div v-if="showForm">
          <p style="float:left;text-align:left">Reset your new password below and we'll send you a link to reset your password.</p>
          <!-- <p style="float:left;text-align:left">Or contact your team manager.</p> -->
          <a-form :form="form" @submit="onSubmit">
            <a-form-item>
              <a-input v-decorator="['email',{ rules: [{
                type: 'email', message: 'The input is not valid E-mail!',
                },{ required: true, message: 'Please input your Email!' }] }]" placeholder="メール">
                <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,.25)" />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-button :loading="isLoading" block type="primary" html-type="submit">RESET</a-button>
            </a-form-item>
          </a-form>
        </div>
        <div v-else>
          <p style="float:left;text-align:center">We have sent a mail to the email address,please check your email.</p>
        </div>
        <a-divider/>
        <a href="/login">Login</a>
      </a-card>
    </a-col>
  </a-row>
</div>
</template>

<script>
export default {
  name: "FogotPassword",
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      isLoading: false,
      showForm: true
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) return;
        this.isLoading = true;
        this.$api.forgotpassword({
            email: values.email
          })
          .then(data => {
            let resp = data.data;

            this.$logger.d("ForgotPassword", "onSubmit api", {
              response: resp
            });
            if (resp.error) {
              this.$notification.error({
                message: "エラー:" + resp.error.code,
                description: resp.error.description
              });
            } else {
              this.showForm = false
            }
            this.isLoading = false;
          })
          .catch(err => {
            this.$logger.e("ForgotPassword", "onSubmit api", {
              error: err
            });
            this.$notification.error({
              message: "エラー",
              description: "サーバ通信エラー"
            });
            this.isLoading = false;
          });
      });
    }
  }
};
</script>
<style scoped>
.css_container {
  margin-top: 100px;
}

.css_card {
  max-width: 500px;
  margin: 0 auto;
}

.css_card_title {
  text-size: 10px;
  margin: 0 0;
  text-align: left;
}
</style>
